import { Fragment } from 'react';

interface BookingProgressProps {
	steps: string[];
	/** 1-based index of the step currently on screen. */
	currentStep: number;
	/** Show every step as complete (used once the booking is confirmed). */
	allDone?: boolean;
	/** Render the "STEP n" eyebrow above each name (paid page only). */
	showStepNumbers?: boolean;
}

/**
 * Numbered step rail shared by both public booking pages.
 *
 * Each step is sized to its circle and label; the connectors between them are
 * flex items sharing the leftover width equally, so every line is the same
 * length whatever the labels say and however wide the screen is.
 */
const BookingProgress = ({
	steps,
	currentStep,
	allDone = false,
	showStepNumbers = false,
}: BookingProgressProps) => (
	<div className="pb__progress">
		{steps.map((name, index) => {
			const stepNumber = index + 1;
			const isDone = allDone || stepNumber < currentStep;
			const isActive = !allDone && stepNumber === currentStep;
			return (
				<Fragment key={name}>
					<div
						className={`pb__progress-step${isActive ? ' is-active' : ''}${
							isDone ? ' is-done' : ''
						}`}
					>
						<div className="pb__step-circle">{isDone ? '✓' : stepNumber}</div>
						<div className="pb__step-info">
							{showStepNumbers && (
								<div className="pb__step-num">Step {stepNumber}</div>
							)}
							<div className="pb__step-name">{name}</div>
						</div>
					</div>
					{index < steps.length - 1 && (
						<div className={`pb__progress-line${isDone ? ' is-done' : ''}`} />
					)}
				</Fragment>
			);
		})}
	</div>
);

export default BookingProgress;
